import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
let Credits = class Credits extends Mixins() {
    get headers() {
        return [
            {
                text: 'TOP-UP ID',
                value: 'id',
                align: 'left',
                sortable: false,
            },
            {
                text: 'AMOUNT',
                value: 'amount',
                align: 'left',
                sortable: false,
                isCurrency: true,
            },
            {
                text: 'PAYMENT METHOD',
                value: 'paymentMethod',
                align: 'left',
                sortable: false,
            },
            {
                text: 'STATUS',
                value: 'status',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DATE & TIME',
                value: 'date',
                align: 'left',
                sortable: false,
            },
        ];
    }
    get requestOnFlight() {
        return this.$apollo.loading;
    }
};
__decorate([
    Prop({ type: Array, required: false })
], Credits.prototype, "credits", void 0);
Credits = __decorate([
    Component
], Credits);
export default Credits;
